import { IconCollection } from "components/Icon/IconCollection";
import { getNewRecordPath } from "components/Layout/Sidebar/components/CreateNew/CreateNew";

export const isRecordDeletedOrHasReadOnlyLocation = (resourceData) =>
    resourceData?.deleted_at !== null ||
    resourceData?.is_project_readonly ||
    resourceData?.is_bundle_readonly;

export const createWebhook = {
    key: "createWebhook",
    action: ({ flowId, history }) =>
        history.push(
            getNewRecordPath("webhook", {
                flow_id: flowId,
            })
        ),
    label: "Create webhook",
    icon: IconCollection.webhook,
    isDisabled: (resourceData) => isRecordDeletedOrHasReadOnlyLocation(resourceData),
};

export const isCreateScheduleDisabled = (resourceData) =>
    isRecordDeletedOrHasReadOnlyLocation(resourceData);
